import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeSearch } from 'shared/actions/search';
import { getDealType } from 'shared/selectors/getDealType';
import { selectDate } from 'shared/selectors/results/selectDate';
import { selectSource } from 'shared/selectors/selectSource';
import { EDealType } from 'shared/types/dealType';
import { IFiltersUpdatedEventDetail } from 'shared/types/microfrontends';
import { TThunkDispatch } from 'shared/types/redux';
import { useApplicationContext } from 'shared/utils/applicationContext';

const EVENT_NAME = 'filters:updated';

/**
 * Подписывается на событие из микрофронта на применение фильтров
 */
export const useFiltersUpdatedEvent = () => {
  const { microfrontendsAPI, microfrontendsRegistry } = useApplicationContext();

  const dispatch = useDispatch<TThunkDispatch>();
  const dates = useSelector(selectDate);
  const dealType = useSelector(getDealType);
  const source = useSelector(selectSource);

  const isDailyRentWithoutDates = source === 'search_string' && dealType === EDealType.RentDaily && !dates;

  useEffect(() => {
    const onFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(makeSearch({ ...detail, withSource: isDailyRentWithoutDates }));

      if (microfrontendsRegistry.microfrontend('search-string-micro-frontend') && microfrontendsAPI) {
        microfrontendsAPI.getSearchStringMicrofrontendAPI().setFilterJsonQuery(detail.jsonQuery);
      }
    };

    addEventListener(EVENT_NAME, onFiltersUpdated);

    return () => {
      removeEventListener(EVENT_NAME, onFiltersUpdated);
    };
  }, [dispatch, isDailyRentWithoutDates, microfrontendsAPI, microfrontendsRegistry]);
};
